import React, { useCallback } from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { SecondaryButton } from '../../../design/components';
import SetupPickerField from '../components/SetupPickerField';
import SetupTextField from '../components/SetupTextField';
import {
	MARKET_SETUP_FOOD_OPTIONS,
	MARKET_SETUP_FOOD_OPTIONS_NAME,
} from '../../../../common/constants';
import { toNumber } from './MarketSetupDetailHelpers';
import { createMarketSetupDetailStyles } from './MarketSetupDetail.styles';

const MarketSetupFoodOptions = ({ marketSetup, updateMarketSetup }) => {
	const styles = useThemedStyles(createMarketSetupDetailStyles);
	const handleFoodOptionChange = useCallback((index, key, value) => {
		const options = marketSetup.foodOptions?.length ? [...marketSetup.foodOptions] : [{ value: null }];
		const nextOption = {
			...(options[index] || {}),
			[key]: key === 'value' ? toNumber(value) : value,
		};

		if (key === 'value' && nextOption.value !== MARKET_SETUP_FOOD_OPTIONS.CUSTOM) {
			nextOption.custom = null;
		}

		options[index] = nextOption;
		updateMarketSetup({ foodOptions: options });
	}, [marketSetup.foodOptions, updateMarketSetup]);

	const handleRemoveFoodOption = useCallback((index) => {
		const options = (marketSetup.foodOptions || []).filter((_, i) => i !== index);
		updateMarketSetup({ foodOptions: options.length ? options : [{ value: null }] });
	}, [marketSetup.foodOptions, updateMarketSetup]);

	const addFoodOption = useCallback(() => {
		const options = marketSetup.foodOptions?.length ? [...marketSetup.foodOptions] : [];
		options.push({ value: null });
		updateMarketSetup({ foodOptions: options });
	}, [marketSetup.foodOptions, updateMarketSetup]);

	return (
		<>
			{
				(marketSetup.foodOptions || [{ value: null }]).map((option, index) => (
					<View key={`food_${index}`} style={styles.bayCard}>
						<SetupPickerField
							label={`Food option ${index + 1}`}
							value={option?.value}
							onChange={value => handleFoodOptionChange(index, 'value', value)}
							options={Object.values(MARKET_SETUP_FOOD_OPTIONS).map(value => ({
								label: MARKET_SETUP_FOOD_OPTIONS_NAME[value],
								value,
							}))}
							required={true}
						/>
						{
							(marketSetup.foodOptions || []).length > 1 && (
								<View style={styles.inlineAction}>
									<SecondaryButton label="Remove" icon="trash-2" onPress={() => handleRemoveFoodOption(index)} />
								</View>
							)
						}
						{
							option?.value === MARKET_SETUP_FOOD_OPTIONS.CUSTOM && (
								<SetupTextField
									label="Custom food option"
									value={option?.custom}
									field="custom"
									onConfirm={({ custom }) => handleFoodOptionChange(index, 'custom', custom)}
									hint="Describe the custom food option."
									required={true}
								/>
							)
						}
					</View>
				))
			}
			<View style={styles.addAction}>
				<SecondaryButton label="Add food option" icon="plus" onPress={addFoodOption} />
			</View>
		</>
	);
};

export default MarketSetupFoodOptions;
